export function initBlogTabsScroll() {
  const tabs = document.querySelector('.blog-tabs');
  if (!tabs) return;

  // On page load — if URL contains #blog-tabs, scroll to the tabs section
  if (window.location.hash === '#blog-tabs') {
    requestAnimationFrame(() => {
      const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      const top = tabs.getBoundingClientRect().top + window.scrollY - offset - 24;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  // Add #blog-tabs hash to all category tab links
  tabs.querySelectorAll('.blog-tabs__tab').forEach((link) => {
    const href = link.getAttribute('href');
    if (href && !href.includes('#')) {
      link.setAttribute('href', href + '#blog-tabs');
    }
  });
}
